import type { CircularProgressProps as ChakraCircularProgressProps } from "@chakra-ui/react";
import { CircularProgress as ChakraCircularProgress } from "@chakra-ui/react";
import type { ChakraSizes } from "types";

const PROGRESS_SIZE: Record<
  Extract<ChakraSizes, "xs" | "sm" | "md" | "lg">,
  string
> = {
  xs: "20px",
  sm: "40px",
  md: "80px",
  lg: "128px",
};

export interface LoaderProps extends ChakraCircularProgressProps {
  size?: Extract<ChakraSizes, "xs" | "sm" | "md" | "lg">;
}

/**
 * Indicate that an action or process is currently in progress when the
 * duration is unknown. Use a spinner to communicate that the system is
 * working and prevent duplicate actions. Use Skeleton for initial layout
 * loading and Progress Bar for measurable progress.
 */
export const Loader = ({ size = "md", ...customStyles }: LoaderProps) => {
  return (
    <ChakraCircularProgress
      isIndeterminate
      thickness="0.375rem"
      capIsRound
      color="highlight.fg"
      trackColor="highlight.subtle"
      size={PROGRESS_SIZE[size]}
      backgroundRepeat="no-repeat"
      backgroundPosition="center"
      height="fit-content"
      width="fit-content"
      {...customStyles}
    />
  );
};
